import React, { useContext, useEffect, useRef } from 'react';
import { ShopContext } from '../shop/ShopConf';
import { addPrintOverlay } from '../utils';
import { BetslipContext } from './BetslipConf';

function DoubleProfileChooser(props) {
	const betslipContext = useContext(BetslipContext);
	
	const doubleProfileValue = betslipContext.provDoubleProfileValue;

	function selectDoubleProfile(value){
		betslipContext.setProvSettings(value);
	}
	
	function onChangeFirstCheckbox(e){
		if(e.target.checked){
			selectDoubleProfile(0);
		}
		else{
			selectDoubleProfile(1);
		}
	}
	function onChangeSecondCheckbox(e){
		if(e.target.checked){
			selectDoubleProfile(1);
		}
		else{
			selectDoubleProfile(0);
		}
	}
	
    return (<div className="bg-bianco bordo-tondo margine-giu widget-betslip">
    	<div className="titolo-widget-stampa maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx">
    		<span> <i className="fas fa-money-bill"></i> MODALITA' PROVVIGIONE </span>
    	</div>
		<div className="contenuto-widget bordato-widget padding-orizzontale padding-verticale">
    		<div className="input-widget">
    			<div className="betslip-container-switch-fastbet">
	    			<label className="custom-switch-2">
	    				<input id="provv-margine" type="checkbox" onChange={onChangeFirstCheckbox} checked={doubleProfileValue === 0} />
	    				<span className="custom-slider-2 round"></span>
	    			</label>
	    			<span className="ml-2">Margine</span>
    			</div>
    		</div>
    		
    		<div className="input-widget">
				<div className="betslip-container-switch-fastbet">
					<label className="custom-switch-2">
						<input id="provv-guadagno" type="checkbox"   onChange={onChangeSecondCheckbox} checked={doubleProfileValue === 1} />
						<span className="custom-slider-2 round"></span>
					</label>
					<span className="ml-2">ByPass</span>
				</div>
			</div>
    	</div>
    </div>
    );

}

export default DoubleProfileChooser;
